import type { AppliedFrameResult, AppliedRow } from './applied-frame';
import { encounterCreatureField } from '../../shared/array-types';

/** U0 carries the actor's complete computed snapshots until U2's finer delta
 * installer replaces this bridge. Respect each member's revision independently. */
export function applyFrameComputed(frame: AppliedFrameResult, member: (id: string) => AppliedRow | undefined, paint: (row: AppliedRow) => void,
    confirmedRev: (id: string, row: AppliedRow) => number = (_id, row) => Number(encounterCreatureField(row.encounter_creatures, 'movement_rev') ?? 0)): void {
    if ('cache_ref' in frame) return;
    for (const [id, computed] of Object.entries(frame.computed)) {
        const row = member(id), rev = frame.member_revs[id];
        if (!row || !Number.isInteger(rev) || confirmedRev(id, row) > rev!) continue;
        row.computed = computed;
        paint(row);
    }
}
